import axios from 'axios';
import { Patient, Consultation, ConsultationForm, PatientInfoForm, ConsultationSubmitForm } from '../pages/consultation_form/types';
import { ApiResponse } from '../types/common';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// 问诊模板数据接口
export interface TemplateQuestion {
    questionId: string;
    question: string;
    type: number;
    required: boolean;
    describe?: string;
    options?: Array<{
        optionId: string;
        questionOption: string;
    }>;
    limitOptionsNumber?: number;
}

export interface TemplateSection {
    typeId: string;
    typeName: string;
    questions: TemplateQuestion[];
}

export interface TemplateData {
    typeList: TemplateSection[];
    [key: string]: any;
}

// 获取问诊模板数据
export const getTemplateData = async (templateId: string): Promise<TemplateData | null> => {
    try {
        const response = await axios.get<ApiResponse<TemplateData>>(
            `${API_BASE_URL}/api/v1/consultation/template/${templateId}`
        );
        return response.data.data;
    } catch (error) {
        console.error('获取问诊模板数据失败:', error);
        return null;
    }
};

export const getPatientList = async (accountId: string): Promise<Patient[]> => {
    try {
        const response = await axios.get<ApiResponse<Patient[]>>(
            `${API_BASE_URL}/api/v1/consultation/patient?accountId=${accountId}`
        );
        return response.data.data;
    } catch (error) {
        console.error('获取患者列表失败:', error);
        return [];
    }
};

export const getPatientDetail = async (id: string): Promise<Patient | null> => {
    try {
        const response = await axios.get<ApiResponse<Patient>>(`${API_BASE_URL}/api/v1/consultation/patient?patientId=${id}`);
        return response.data.data;
    } catch (error) {
        console.error('获取患者详情失败:', error);
        return null;
    }
};

export const getPatientRecords = async (accountId: string): Promise<Consultation[]> => {
    try {
        const response = await axios.get<ApiResponse<Consultation[]>>(
            `${API_BASE_URL}/api/v1/consultations?account_id=${accountId}`
        );
        return response.data.data;
    } catch (error) {
        console.error('获取问诊记录失败:', error);
        return [];
    }
};

export const submitConsultation = async (data: ConsultationForm): Promise<string | null> => {
    try {
        const response = await axios.post<ApiResponse<string>>(
            `${API_BASE_URL}/api/v1/consultations`,
            data
        );
        return response.data.data;
    } catch (error) {
        console.error('提交问诊失败:', error);
        return null;
    }
};

export const getConsultationDetail = async (id: string): Promise<Consultation | null> => {
    try {
        const response = await axios.get<ApiResponse<Consultation>>(
            `${API_BASE_URL}/api/v1/consultations/${id}`
        );
        return response.data.data;
    } catch (error) {
        console.error('获取问诊详情失败:', error);
        return null;
    }
};

// 这个方法不要修改，因为接口的data返回的就是recordId，他并不是一个json格式
export const savePatientInfo = async (formData: PatientInfoForm): Promise<ApiResponse<{ recordId: string }>> => {
    try {
        const response = await axios.post<ApiResponse<string>>(`${API_BASE_URL}/api/v1/consultation/base`, formData);
        return { data: { recordId: response.data.data }, code: 200, message: 'success' };
    } catch (error) {
        console.error('保存患者信息失败:', error);
        throw error;
    }
};

export const submitConsultationForm = async (formData: ConsultationSubmitForm) => {
    try {
        const response = await axios.post<ApiResponse<string>>(
            `${API_BASE_URL}/api/v1/consultation/question`,
            formData
        );
        return response.data.data;
    } catch (error) {
        console.error('提交问诊表单失败:', error);
        throw error;
    }
}; 